import React, { memo } from 'react';
import { Text } from 'core/components';
import { inject } from 'mobx-react';
import SudoTag from 'app/components/SudoTag';
import Markdown from '../../journeys/Markdown';
import { MessageItem, UserMessageBubble, MessageHeader, Timestamp } from '../KaizenChatSession.styles';

const userPromptRegex = /User prompt:\s*(.*?)$/s;

// Memoized user message component
const UserMessage = memo(({ $auth, message, formatDate }) => {
  // Extract the user prompt from the message text if it contains context

  const extractUserPrompt = (messageText) => {
    // Regex to match everything after "User prompt: " until the end of the string
    const match = messageText.match(userPromptRegex);

    // If we find a match, return the extracted prompt, otherwise return the original message
    return match ? match[1].trim() : messageText;
  };

  // Check if the message contains context (regex matched)
  const hasContext = userPromptRegex.test(message.message_text);

  const displayText = $auth.hasSudo ? message.message_text : extractUserPrompt(message.message_text);

  return (
    <MessageItem key={`user-${message.id}`}>
      <UserMessageBubble>
        <MessageHeader isUser>
          <Text>{message.user?.user_full_name || 'User'}</Text>
          <Timestamp isUser>{formatDate(message.created_at)}</Timestamp>
        </MessageHeader>
        {$auth.hasSudo && hasContext && <SudoTag fontSize={10} style={{ alignSelf: 'flex-start' }} />}
        <Markdown>{displayText}</Markdown>
      </UserMessageBubble>
    </MessageItem>
  );
});

UserMessage.displayName = 'UserMessage';

export default inject('$auth')(UserMessage);
